module.exports = __webpack_public_path__ + "img/dekkho.e617c2f9.png";